'use client';

import React, { useState } from 'react';
import { dispatchChatbotOpen } from './chatbot-open-event';
import { cn } from '../../utilities/classname';

export const ChatbotInlineInput: React.FC<{
  placeholder?: string;
  buttonText?: string;
  className?: string;
}> = ({
  placeholder = 'What are you looking for?',
  buttonText = 'Ask',
  className,
}) => {
  const [value, setValue] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    dispatchChatbotOpen({ initialMessage: trimmed });
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit} className={cn('join w-full', className)}>
      <input
        type="text"
        className="input input-bordered join-item grow"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button type="submit" className="btn btn-primary join-item">
        {buttonText}
      </button>
    </form>
  );
};
